module.exports = __webpack_public_path__ + "img/badge160.0c16ce21.png";